import { FormattedMessage } from 'react-intl';

export const DocumentTypeLabel = ({ label }: { label: string }) => {
    switch (label) {
        case 'agedDebtorReport':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.aged_debtor_report"
                    defaultMessage="Aged Debtor Report"
                />
            );
        case 'vatReturn':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.vat_return"
                    defaultMessage="VAT Return"
                />
            );
        case 'bankStatement':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.bank_statement"
                    defaultMessage="Bank Statement"
                />
            );
        case 'businessPlan':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.business_plan"
                    defaultMessage="Business Plan"
                />
            );
        case 'filedAccounts':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.filed_accounts"
                    defaultMessage="Filed Accounts"
                />
            );
        case 'managementAccounts':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.management_accounts"
                    defaultMessage="Management Accounts"
                />
            );
        case 'personalID':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.personal_id"
                    defaultMessage="Personal ID"
                />
            );
        case 'shareholderID':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.shareholder_id"
                    defaultMessage="Shareholder ID"
                />
            );
        case 'shareholderRegistry':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.shareholder_registry"
                    defaultMessage="Share Registry"
                />
            );
        case 'businessAccounts':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.business_accounts"
                    defaultMessage="Business Accounts"
                />
            );
        case 'companyBylaws':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.company_by_laws"
                    defaultMessage="Company Bylaws"
                />
            );
        case 'tradeCertificate':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.trade_certificate"
                    defaultMessage="Trade Certificate"
                />
            );
        case 'articlesOfAssociation':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.articles_of_association"
                    defaultMessage="Articles of Association"
                />
            );
        case 'selfAssessmentTaxReturn':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.self_assessment_tax_return"
                    defaultMessage="Self Assessment Tax Return"
                />
            );
        case 'personalBankStatement':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.personal_bank_statement"
                    defaultMessage="Personal Bank Statement"
                />
            );
        case 'limitedPartnerID':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.limited_partner_id"
                    defaultMessage="Limited Partner ID"
                />
            );
        case 'PNLBalance':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.pnl_balance"
                    defaultMessage="PnL Balance"
                />
            );
        case 'profitAndLoss':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.profit_and_loss"
                    defaultMessage="Profit and Loss"
                />
            );
        case 'customerBrokerConsent':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.customer_broker_consent"
                    defaultMessage="Customer Broker Consent"
                />
            );
        case 'cashRegister':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.cash_register"
                    defaultMessage="Cash Register"
                />
            );
        case 'certificados':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.certificados"
                    defaultMessage="Certificados"
                />
            );
        case 'balanceSheet':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.balance_sheet"
                    defaultMessage="Balance Sheet"
                />
            );
        case 'managementAndBalanceAccounts':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.management_and_balance_accounts"
                    defaultMessage="Management and Balance Accounts"
                />
            );
        case 'yearEndManagementAndBalanceAccounts':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.year_end_management_and_balance_accounts"
                    defaultMessage="Year End Management and Balance Accounts"
                />
            );
        case 'yearEndManagementAccounts':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.year_end_management_accounts"
                    defaultMessage="Year End Management Accounts"
                />
            );
        case 'accountBalances':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.account_balances"
                    defaultMessage="Account Balances"
                />
            );
        case 'cashflowForecast':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.cashflow_forecast"
                    defaultMessage="Cashflow forecast"
                />
            );
        case 'outstandingDebtInformation':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.outstanding_debt_information"
                    defaultMessage="Debt position"
                />
            );
        case 'listOfShareholders':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.list_of_shareholders"
                    defaultMessage="List of shareholders"
                />
            );
        case 'other':
            return (
                <FormattedMessage
                    id="_.trading_data.uploaded_documents.other"
                    defaultMessage="Other"
                />
            );
        default:
            return null;
    }
};
